import '../../scss/widget.scss';
import * as AIChat from './driftrock_ai_chat'
import * as Attribution from './driftrock_attribution';
import * as Form from '../form';
import * as FormHelpers from './forms/helpers';
import * as CalendlyBookEvent from '../calendly_book_event';


function sendEventWithGA(config, form) {
  if (typeof (gtag) === 'function' && config.tracking_google_analytics_measurement_id) {
    gtag('get', config.tracking_google_analytics_measurement_id, 'client_id', (client_id) => {
      sendEvent(form, config, client_id);
    })
  } else {
    if (typeof (ga) === 'function') {
      ga(function () {
        var trackers = ga.getAll();

        if (trackers.length == 0) {
          console.warn('[Driftrock] No Google Analytics Trackers available');
          sendEvent(form, config, null);
          return;
        }

        if (trackers.length > 1 && !config.tracking_google_analytics_id) {
          console.warn('[Driftrock] Multiple Google Analytics Trackers but Tracker ID not specified');
          sendEvent(form, config, null);
          return;
        }

        if (trackers.length == 1 && !config.tracking_google_analytics_id) {
          const ga_client_id = trackers[0].get('clientId');
          return sendEvent(form, config, ga_client_id);
        }

        for (var i = 0; i < trackers.length; i += 1) {
          if (trackers[i].get('trackingId') === config.tracking_google_analytics_id) {
            const ga_client_id = trackers[i].get('clientId');
            return sendEvent(form, config, ga_client_id);
          }
        }

        console.warn('[Driftrock] Cannot find Google Analytics tracker with ID ' + config.tracking_google_analytics_id);
        sendEvent(form, config, null);
      });
    } else {
      console.warn('[Driftrock] Google Analytics not setup');
      sendEvent(form, config, null);
    }
  }
}

function clickIds(drFirstTouchCookie) {
  return {
    fbclid: drFirstTouchCookie.fbclid,
    gclid: drFirstTouchCookie.gclid,
    li_fat_id: drFirstTouchCookie.li_fat_id,
    sc_cid: drFirstTouchCookie.sc_cid,
  };
}

function sendEvent(form, config, ga_client_id) {
  const field_inputs = form.querySelectorAll('.driftrock [data-form-field-value]');
  var fields =
    Object.fromEntries(
      [...field_inputs]
        .filter(field => field.dataset.visible != 'false')
        .map(field => {
          switch (field.dataset.formFieldType) {
            case "checkbox":
              return [field.dataset.formFieldName, field.checked.toString()]
            case "radiobuttons":
              const input = field.querySelector('input:checked')
              return [field.dataset.formFieldName, input.value]
              break;
            default:
              return [field.name, field.value]
              break;
          }
        })
    );

  // we probably want to interpret "referer" as the page
  // the form is hosted on, but there might still value
  // in knowing the actual referer (let's keep this in mind)
  const referer = document.location.toString();
  const location_params = FormHelpers.locationParams(location.search)
  const first_touch = Attribution.get_first_touch() || {};
  const hidden_fields = Driftrock.widget_settings.hidden_fields;

  var payload = {
    event_name: 'Lead Submitted',
    event_type: 'lead',
    source_id: config.widget_id,
    fields: { ...fields, ...hidden_fields },
    metadata: {
      ...clickIds(first_touch),
      referer: referer,
      utm_campaign: first_touch['utm_campaign'] || location_params.utm_campaign,
      utm_content: first_touch['utm_content']|| location_params.utm_content,
      utm_medium: first_touch['utm_medium'] || location_params.utm_medium,
      utm_source: first_touch['utm_source'] || location_params.utm_source,
      utm_term: first_touch['utm_utm_term']
        || first_touch['utm_keyword']
        || location_params.utm_term
        || location_params.utm_keyword
    }
  }

  if (ga_client_id) {
    payload.metadata.ga_client_id = ga_client_id;
  }

  FormHelpers.showLoading(form);

  fetch(
    `${Driftrock.settings.base_url}/v2/widget_event`,
    {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${Driftrock.settings.api_key}`,
        'Content-Type': 'application/json'
      },
      method: 'post',
      body: JSON.stringify(payload)
    }
  )
    .then(FormHelpers.handleApiError)
    .then(response => response.json())
    .then(data => {
      sendGASubmitEvent(config);

      FormHelpers.markFormAsSubmitted(config.widget_id, "widget")

      setTimeout(() => {
        [...getFormContainers(config)].forEach((form) => FormHelpers.showThankYou(form));
      }, 1000);
    })
    .catch(error => submitErrorCallback(config, error, form));
}

function setupForm(config) {
  [...getFormContainers(config)].forEach((form_container) => {
    if (config.widget_type == "aichat") { AIChat.init(form_container, config); }

    const submit_button = form_container.querySelector('[data-form-submit]');

    if (submit_button) {
      submit_button.addEventListener('click', function (e) {
        e.preventDefault();

        if (!FormHelpers.validateForm(form_container)) {
          FormHelpers.showValidationErrors(form_container);
          return;
        }

        CalendlyBookEvent.show(form_container);

        if (config.preview) {
          FormHelpers.showThankYou(form_container);
        } else {
          sendEventWithGA(config, form_container);
          trackWidget(config, "submit");
        }
      })
    }

    const collapse_buttons = form_container.querySelectorAll('.driftrock-bar-collapse')
    const close_buttons = form_container.querySelectorAll('.driftrock-close');

    if (close_buttons.length > 0) {
      [...close_buttons].forEach((close_button) => {
        close_button.addEventListener('click', function (e) {
          hideWidget(config);

          FormHelpers.markFormAsHidden(config.widget_id, "widget")
        });
      });
    }

    if (collapse_buttons.length > 0) {
      [...collapse_buttons].forEach((collapse_button) => {
        collapse_button.addEventListener('click', function (e) {
          toggleBar(config);
        });
      });
    }

    form_container.addEventListener('input', function (e) {
      if (!config.preview) {
        trackWidget(config, "engaged")
      }
    }, { once: true })
  });
}

function submitErrorCallback(config, error, form) {
  submitError(error)
  FormHelpers.showForm(form);
  FormHelpers.showError(form);
}

function loadWidgetContents({ configs }) {
  configs.forEach((config_response) => {
    try {
      let config = cleanConfig(config_response)

      window.Driftrock.widgets.set(config.widget_id, config);

      const widget_container = document.querySelector(`#${config.widget_container_id}`);

      if (widget_container) {
        const widgetContent = widget_container.querySelector("[data-widget-content]")

        widgetContent.innerHTML = config.widget_html;

        if (canFormBeShown(config)) {
          setupForm(config);

          switch (config.widget_rules.trigger) {
            case "page_load":
              setTimeout(() => showWidget(config), config.widget_rules.trigger_options.delay);

              break;
            case "click":
              const elements = document.querySelectorAll(config.widget_rules.trigger_options.css_selector);

              [...elements].forEach((e) => {
                trackWidget(config, "launcher_show");
                e.addEventListener('click', () => showWidget(config))
              });

              break;
          }

          if (Driftrock.settings.debug) {
            console.info(`[Driftrock] widget ${config.widget_id} initialised`);
          }
          if (config.preview) {
            console.info(`[Driftrock] widget ${config.widget_id} in preview mode, leads won't be submitted`);
          }
        }
      }
    } catch (error) {
      configError(error);
    }
  });

  Form.init(document);

  CalendlyBookEvent.init();

  return { configs };
}

function canFormBeShown(config) {
  if (config.widget_type == "inline_form") {
    if (document.querySelector(config.widget_options.container_css_selector)) {
      return true;
    } else {
      console.warn('[Driftrock] Cannot find inline form container');
      return false;
    }
  }
  return true;
}

function sendGAViewEvent(config) {
  if (config.send_ga_events) {
    if (typeof (gtag) === 'function') {
      gtag('event', 'form_viewed', { event_category: 'Driftrock Forms', event_label: config.widget_name });
    } else {
      if (typeof (ga) === 'function') {
        ga('send', 'event', 'Driftrock Forms', 'form_viewed', config.widget_name);
      } else {
        console.warn('[Driftrock] Google Analytics not setup');
      }
    }
  }
}

function sendGASubmitEvent(config) {
  if (config.send_ga_events) {
    if (typeof (gtag) === 'function') {
      gtag('event', 'form_submitted', { event_category: 'Driftrock Forms', event_label: config.widget_name });
    } else {
      if (typeof (ga) === 'function') {
        ga('send', 'event', 'Driftrock Forms', 'form_submitted', config.widget_name);
      } else {
        console.warn('[Driftrock] Google Analytics not setup');
      }
    }
  }
}

function showWidgetById(widget_id) {
  if (widget_id) {
    const config = Driftrock.widgets.get(widget_id);

    if (config) {
      showWidget(config);
    }
  }
}

function hideWidgets() {
  Driftrock.widgets.forEach(hideWidget);
}

function hideWidgetById(widget_id) {
  if (widget_id) {
    const config = Driftrock.widgets.get(widget_id);

    if (config) {
      hideWidget(config);
    }
  }
}

function showWidget(config) {
  sendGAViewEvent(config);

  const dismissed = wasWidgetDismissed(config.widget_id)
  const submitted = wasWidgetSubmitted(config.widget_id)
  const never_interacted_with = !dismissed && !submitted
  const always_submittable = (config.multiple_submit_enabled == true)
  const should_show_on_page_load = always_submittable || never_interacted_with
  const should_show_thankyou_page = submitted && !always_submittable

  const will_show = (config.widget_type == "inline_form")
    || (config.widget_type == "aichat")
    || (config.widget_type == "launcher")
    || (config.widget_rules.trigger == "page_load" && should_show_on_page_load)
    || (config.widget_rules.trigger == "click")
    || (config.widget_rules.trigger == "javascript")

  if (will_show) {
    showWidgetBasedOnType(config)
  }

  if (should_show_thankyou_page) {
    const form_container = getFormContainer(config);
    CalendlyBookEvent.show(form_container);
    FormHelpers.showThankYou(form_container);
  }
}

function showWidgetBasedOnType(config) {
  switch (config.widget_type) {
    case "bar":
      showBar(config);
      trackWidget(config, "launcher_show");
      break;
    case "aichat":
      showLauncher(config);
      trackWidget(config, "launcher_show");
      break;
    case "launcher":
      showLauncher(config);
      trackWidget(config, "launcher_show");
      break;
    case "modal":
      showModal(config);
      trackWidget(config, "show");
      break;
    case "slide_in":
      showSlideIn(config);
      trackWidget(config, "show");
      break;
    case "inline_form":
      showInlineForm(config);
      trackWidget(config, "show");
      break;
  }
}

function hideWidget(config) {
  switch (config.widget_type) {
    case "bar":
      hideBar(config);
      break;
    case "aichat":
      hideLauncher(config);
      break;
    case "launcher":
      hideLauncher(config);
      break;
    case "modal":
      hideModal(config);
      break;
    case "slide_in":
      hideSlideIn(config);
      break;
    case "inline_form":
      hideInlineForm(config);
      break;
  }
  if (!wasWidgetSubmitted(config.widget_id)) {
    trackWidget(config, "dismiss")
  }
}

function wasWidgetDismissed(widget_id) {
  if (widget_id) {
    return FormHelpers.wasFormHidden(widget_id, "widget")
  }
}

function wasWidgetSubmitted(widget_id) {
  if (widget_id) {
    return FormHelpers.wasFormSubmitted(widget_id, "widget")
  }
}

function resetWidgetCookies(widget_id) {
  if (widget_id) {
    return FormHelpers.resetFormCookies(widget_id, "widget")
  }
}

function showModal(config) {
  const modal = getFormContainer(config);

  setTimeout(() => {
    modal.classList.remove('invisible');
  });
}

function hideModal(config) {
  const modal = getFormContainer(config);

  setTimeout(() => modal.classList.add('invisible'));
}

function showBar(config) {
  switch (config.widget_options.position) {
    case "top":
      setupTopBar(config);
      showTopBar(config);
      break;
    case "bottom":
      setupBottomBar(config);
      showBottomBar(config);
      break;
  }
}

function setupTopBar(config) {
  const bar = getFormContainer(config);
  var expand_buttons = document.querySelectorAll('.driftrock-bar-collapsed__cta');

  bar.classList.add('driftrock-bar--top');

  const height = bar.getBoundingClientRect().height;
  FormHelpers.setStyle(bar, 'top', `-${height}px`);
  FormHelpers.setStyle(document.body, 'transition', `margin-top .5s ease`);
  if (expand_buttons.length > 0) {
    [...expand_buttons].forEach((expand_button) => {
      expand_button.addEventListener('click', function (e) {
        if (isCollapsedBar(config)) {
          trackWidget(config, "show");
        }
        toggleBar(config)
      });
    });
  }
}

function showTopBar(config) {
  const bar = getFormContainer(config);
  const height = bar.getBoundingClientRect().height;

  setTimeout(() => {
    FormHelpers.setStyle(bar, 'max-height', `${height}px`);
    FormHelpers.setStyle(bar, 'visibility', 'visible');
    FormHelpers.setStyle(document.body, 'margin-top', `${height}px`);
    FormHelpers.setStyle(bar, 'top', `0px`);
  }, 500);
}

function setupBottomBar(config) {
  const bar = getFormContainer(config);
  var expand_buttons = document.querySelectorAll('.driftrock-bar-collapsed__cta');

  bar.classList.add('driftrock-bar--bottom');

  const height = bar.getBoundingClientRect().height;
  FormHelpers.setStyle(bar, 'bottom', `-${height}px`);
  FormHelpers.setStyle(document.body, 'transition', `margin-bottom .5s ease`);

  if (expand_buttons.length > 0) {
    [...expand_buttons].forEach((expand_button) => {
      expand_button.addEventListener('click', function (e) {
        if (isCollapsedBar(config)) {
          trackWidget(config, "show");
        }
        toggleBar(config)
      });
    });
  }
}

function showBottomBar(config) {
  const bar = getFormContainer(config);
  const height = bar.getBoundingClientRect().height;

  setTimeout(() => {
    FormHelpers.setStyle(bar, 'max-height', `${height}px`);
    FormHelpers.setStyle(bar, 'visibility', 'visible');
    FormHelpers.setStyle(document.body, 'margin-bottom', `${height}px`);
    FormHelpers.setStyle(bar, 'bottom', `0px`);
  }, 500);
}

function toggleBar(config) {
  const bar = getFormContainer(config);
  var collapsed_bar_mobile = document.querySelector('.driftrock-bar__collapsed.is-hidden-mobile');
  var collapsed_bar_tablet = document.querySelector('.driftrock-bar__collapsed.is-hidden-tablet');
  var expanded_bar = bar.querySelector('.driftrock-bar__expanded');
  var expand_buttons = bar.querySelectorAll('.driftrock-bar-collapsed__cta');
  var collapse_buttons = bar.querySelectorAll('.driftrock-bar-collapse');
  var close_buttons = bar.querySelectorAll('.driftrock-close')
  var bar_content = bar.querySelector('.driftrock-bar-content');

  const height = Math.max(collapsed_bar_mobile.getBoundingClientRect().height, collapsed_bar_tablet.getBoundingClientRect().height)

  if (isCollapsedBar(config)) {
    expanded_bar.classList.remove('driftrock-bar__expanded--invisible');
    bar.classList.remove('driftrock-bar--collapsed');
    FormHelpers.setStyle(bar, 'max-height', '100%');
    FormHelpers.setStyle(bar_content, 'overflow-y', 'hidden');
    setTimeout(() => FormHelpers.unsetStyle(bar_content, 'overflow-y'), 500);
    [...close_buttons].forEach((btn) => FormHelpers.setStyle(btn, 'visibility', 'hidden'));
    [...collapse_buttons].forEach((btn) => FormHelpers.setStyle(btn, 'visibility', 'visible'));
    [...expand_buttons].forEach((btn) => btn.classList.add("invisible"));
  } else {
    bar.classList.add('driftrock-bar--collapsed');
    switch (config.widget_options.position) {
      case "top":
        FormHelpers.setStyle(bar, 'max-height', `auto`);
        expanded_bar.classList.add('driftrock-bar__expanded--invisible');
        break;
      case "bottom":
        FormHelpers.setStyle(bar, 'max-height', `auto`);
        expanded_bar.classList.add('driftrock-bar__expanded--invisible');
        break;
    }
    [...close_buttons].forEach((btn) => FormHelpers.setStyle(btn, 'visibility', 'visible'));
    [...collapse_buttons].forEach((btn) => FormHelpers.setStyle(btn, 'visibility', 'hidden'));
    [...expand_buttons].forEach((btn) => btn.classList.remove("invisible"));
  }
}

function isCollapsedBar(config) {
  const bar = getFormContainer(config);
  return bar.classList.contains('driftrock-bar--collapsed')
}

function hideBar(config) {
  var bar = document.querySelector('.driftrock-bar');
  const height = bar.getBoundingClientRect().height;

  if (config.widget_options.position == "top") {
    FormHelpers.setStyle(bar, 'top', `-${height}px`);
    setTimeout(() => FormHelpers.setStyle(document.body, 'margin-top', '0px'));
  } else {
    FormHelpers.setStyle(bar, 'bottom', `-${height}px`);
    setTimeout(() => FormHelpers.setStyle(document.body, 'margin-bottom', '0px'));
  }
}

function showLauncher(config) {
  setupLauncher(config);
}

function setupLauncher(config) {
  var expand_buttons = document.querySelectorAll(`.driftrock-${config.widget_type}-trigger__cta`);

  if (expand_buttons.length > 0) {
    [...expand_buttons].forEach((expand_button) => {
      expand_button.addEventListener('click', function (e) {
        toggleLauncher(config)
        trackWidget(config, "show");
      });
    });
  }
}

export function expandLauncher(config) {
  var launcher_content = document.querySelector(`.driftrock-${config.widget_type}`);

  if (launcher_content.classList.contains('invisible')) {
    launcher_content.classList.remove('invisible');
  }
}

function toggleLauncher(config) {
  var launcher_content = document.querySelector(`.driftrock-${config.widget_type}`);

  if (launcher_content.classList.contains('invisible')) {
    launcher_content.classList.remove('invisible');
  } else {
    launcher_content.classList.add('invisible');
  }
}

function hideLauncher(config) {
  var launcher_content = document.querySelector(`.driftrock-${config.widget_type}`);
  launcher_content.classList.add('invisible');
}

function showSlideIn(config) {
  const slide_in = getFormContainer(config);

  slide_in.classList.remove("invisible")
  slide_in.classList.add(`driftrock-slide-in--${config.widget_options.position}`);

  const height = slide_in.getBoundingClientRect().height;
  FormHelpers.setStyle(slide_in, 'bottom', `-${height}px`);
  setTimeout(() => {
    FormHelpers.setStyle(slide_in, 'transition', `bottom .5s ease`);
  }, 50);


  setTimeout(() => {
    FormHelpers.setStyle(slide_in, 'bottom', `0px`);
  }, 500);
}

function hideSlideIn(config) {
  const slide_in = getFormContainer(config);

  const height = slide_in.getBoundingClientRect().height;
  FormHelpers.setStyle(slide_in, 'bottom', `-${height}px`);
  setTimeout(() => slide_in.classList.add("invisible"), 500);
}

function showInlineForm(config) {
  const containers = getFormContainers(config);
  [...containers].forEach((container) => {
    container.classList.remove("invisible");
  });
}

function hideInlineForm(config) {
  const containers = getFormContainers(config);
  [...containers].forEach((container) => {
    container.classList.add("invisible");
  });
}

function initWidgets() {
  const apiKey = Driftrock.settings.api_key;
  const url = document.location;

  loadWidgets(apiKey, url)
    .then(extractContext)
    .then(loadWidgetContainers)
    .then(loadWidgetContents)
    .catch(configError)
}

function extractContext(config) {
  let clean_configs = config.configs.map(({ widget_html, ...rest }) => rest);

  Driftrock.company_id = config.company_id;
  Driftrock.context = clean_configs;

  return config;
}

function loadWidgets(apiKey, url) {
  return fetch(`${Driftrock.settings.base_url}/v2/widget_config`, {
    headers: {
      "Accept": "application/json",
      "Authorization": `Bearer ${apiKey}`,
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({ url }),
  }).then(FormHelpers.handleApiError)
    .then(response => response.json())
}

function loadWidgetContainers({ containers, ...rest }) {
  containers.forEach(({ html, selector }) => {
    if (selector) {
      document
        .querySelectorAll(cssClassSelector(selector))
        .forEach((container) => container.innerHTML = html);
    } else {
      document.body.insertAdjacentHTML('beforeend', html)
    }
  });

  return rest;
}

function cssClassSelector(selector) {
  if (selector.startsWith(".")) return selector;

  return `.${selector}`
}

function reset_widgets() {
  hideWidgets();

  const widgets = document.querySelectorAll('div.driftrock');

  [...widgets].forEach((w) => {
    w.remove();
  });
}

function trackWidget(config, action) {
  trackActionInGTM(config, action);

  fetch(
    `${Driftrock.settings.base_url}/v2/widget_tracking`,
    {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${Driftrock.settings.api_key}`,
        'Content-Type': 'application/json'
      },
      method: 'post',
      body: JSON.stringify({
        source_id: config.widget_id,
        company_id: config.company_id,
        page_url: window.location.href,
        widget_type: config.widget_type,
        widget_trigger: config.widget_rules.trigger,
        widget_positon: config.widget_options.position,
        action: action
      })
    }

  )
    .then(FormHelpers.handleApiError)
    .then(response => response.json())
    .catch(error => trackError(error));
}

function trackActionInGTM(config, action) {
  if (typeof(driftrockDataLayer) == 'object') {
    driftrockDataLayer.push({
      event: 'driftrock_event',
      eventCategory: 'widgets',
      driftrock_action: action,
      driftrock_widget_id: config.widget_id,
      driftrock_widget_name: config.widget_name,
      driftrock_widget_type: config.widget_type,
    });
  }
}

function reportError(error, stage) {
  FormHelpers.reportError(
    Driftrock.settings.base_url,
    error,
    {
      stage: "submit",
      company_id: Driftrock.company_id,
      context: Driftrock.context
    }
  );
}

function submitError(error) {
  reportError(error, "submit")

  console.error('Driftrock Widget submit failed');

  if (Driftrock.settings.debug) {
    console.warn(error);
  }
}

function configError(error) {
  reportError(error, "config")

  console.error('Driftrock Widget setup failed');

  if (Driftrock.settings.debug) {
    console.warn(error);
  }
}

function trackError(error) {
  reportError(error, "track")

  console.error('Driftrock Widget tracking event failed');

  if (Driftrock.settings.debug) {
    console.warn(error);
  }
}

function getFormContainer(config) {
  return document.querySelector(`[data-driftrock-form="${config.widget_id}"]`);
}

function getFormContainers(config) {
  return document.querySelectorAll(`[data-driftrock-form="${config.widget_id}"]`);
}

function cleanConfig(config) {
  let container_selector = config.widget_options.container_css_selector;

  if (container_selector && !container_selector.startsWith(".")) {
    container_selector = `.${container_selector}`;
  }

  config.widget_options.container_css_selector = container_selector;

  return config
}

export function init () {
  if (Driftrock.settings.debug) {
    console.info("[Driftrock] Initialising widget");
  }

  window.Driftrock.widgets = new Map();
  window.Driftrock.context = null;
  window.Driftrock.show_widget = (widget_id) => showWidgetById(widget_id);
  window.Driftrock.hide_widget = (widget_id) => hideWidgetById(widget_id);
  window.Driftrock.widget_was_dismissed = (widget_id) => wasWidgetDismissed(widget_id);
  window.Driftrock.widget_was_submitted = (widget_id) => wasWidgetSubmitted(widget_id);
  window.Driftrock.reset_widget_cookies = (widget_id) => resetWidgetCookies(widget_id);
  window.Driftrock.reset_widgets = () => reset_widgets();

  maybeInjectGTM();
  initWidgets();
}

// Function to create and append the GTM script tag
function maybeInjectGTM() {
  const gtmContainerID = window.Driftrock.config?.widgets_config?.gtm_container_id

  if (typeof gtmContainerID === 'string' && gtmContainerID.length > 0) {
    // Create the GTM script element
    var gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmContainerID}&l=driftrockDataLayer`;

    // Insert the script into the <head>
    document.head.appendChild(gtmScript);

    // Create the GTM noscript iframe element
    var gtmNoscript = document.createElement('noscript');
    gtmNoscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmContainerID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    // Insert the noscript iframe into the <body>
    document.body.appendChild(gtmNoscript);

    // Initialize the driftrockDataLayer
    window.driftrockDataLayer = window.driftrockDataLayer || [];
    window.driftrockDataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
  }
}
